export type InstallPlatform = 'ios' | 'android' | 'desktop';

export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export function detectInstallPlatform(
  userAgent: string,
  maxTouchPoints = 0,
): InstallPlatform {
  if (/iPad|iPhone|iPod/i.test(userAgent)) return 'ios';
  if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';
  return 'desktop';
}

export function isPwaStandalone(input: {
  iosStandalone?: boolean;
  displayModes?: Partial<Record<'standalone' | 'fullscreen' | 'minimal-ui', boolean>>;
}): boolean {
  if (input.iosStandalone) return true;
  const modes = input.displayModes ?? {};
  return Boolean(modes.standalone || modes.fullscreen || modes['minimal-ui']);
}

export function readPwaStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return isPwaStandalone({
    iosStandalone: Boolean(nav.standalone),
    displayModes: {
      standalone: window.matchMedia('(display-mode: standalone)').matches,
      fullscreen: window.matchMedia('(display-mode: fullscreen)').matches,
      'minimal-ui': window.matchMedia('(display-mode: minimal-ui)').matches,
    },
  });
}
